module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"itemsLabel":"Você pode adicionar até 10 itens diferentes"},"en-US":{"itemsLabel":"You can add up to 10 different items"}}')
  delete Component.options._Ctor
}
